import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';
import { IBureauConfig } from '../../../core/shared/classes/bureau';
import { TablePaginate } from '../../../shared/classes/table-paginate';


@Injectable()
export class AgenceService {

    constructor (private apiService: ApiService) {}

    insertBureau(data: any): Observable<ApiResponse> {
        return this.apiService.post('bureau', data);
    }

    updateBureau(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('bureau/' + id, data);
    }

    getBureaux(id_agence: string, withAcl?: string): Observable<ApiResponse> {
        return this.apiService.get('bureau/agence/' + id_agence + (withAcl ? '/acl/' + withAcl : ''));
    }

    getBureauConfig(bureauxId): Observable<ApiResponse> {
        return this.apiService.get(`bureau-configuration/${bureauxId}`);
    }

    saveBureauConfig(bureauxId, data: IBureauConfig): Observable<ApiResponse> {
        return this.apiService.post(`bureau-configuration/${bureauxId}`, data);
    }

    getBureau(id: string): Observable<ApiResponse> {
        return this.apiService.get('bureau/' + id);
    }

    getOrganisation(): Observable<ApiResponse> {
        return this.apiService.get('organisation');
    }

    getMigrations(): Observable<ApiResponse> {
        return this.apiService.get('migration');
    }

    migrate(ref?: string, data?: any): Observable<ApiResponse> {
        return this.apiService.post('migration-process' + (ref ? '/' + ref : ''), data);
    }

    updateMigration(id: string, data?: any): Observable<ApiResponse> {
        return this.apiService.put('migration/' + id, data);
    }

    getAgence(): Observable<ApiResponse> {
        return this.apiService.get('agence');
    }

    getVersionNote(): Observable<any> {
        return this.apiService.get('change-log');
    }

    getBureauConcerne(resourceId: string, resource: string, paginate?: TablePaginate): Observable<ApiResponse> {
        return this.apiService.get('bureau-concerne'
            + (resource === 'bureau' ? '/bureau/' + resourceId : '')
            + (resource === 'role' ? '/role/' + resourceId : '')
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
        );
    }

    insertBureauConcerne(data?: any): Observable<ApiResponse> {
        return this.apiService.post('bureau-concerne', data);
    }

    deleteBureauConcerne(bureauConcerneId: string): Observable<ApiResponse> {
        return this.apiService.delete('bureau-concerne/' + bureauConcerneId);
    }
}
